import { Cron } from "croner";
import { useMemo } from "react";

interface CronPreviewProps {
  cron: string;
  timezone: string;
  variant?: "compact" | "detailed";
}

export function CronPreview({
  cron,
  timezone,
  variant = "compact",
}: CronPreviewProps): JSX.Element | null {
  const nextRuns = useMemo(() => {
    try {
      const job = new Cron(cron, { timezone });
      return job.nextRuns(3).map((d) =>
        d.toLocaleString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
          timeZone: timezone,
        }),
      );
    } catch {
      return null;
    }
  }, [cron, timezone]);

  if (!nextRuns || nextRuns.length === 0) return null;

  if (variant === "detailed") {
    return (
      <div className="mt-2 rounded-md border border-cyber-border/60 bg-cyber-bg/40 p-2.5">
        <div className="mb-1 text-[10px] uppercase tracking-wider text-cyber-muted/70">
          Next runs
        </div>
        <ul className="space-y-1">
          {nextRuns.map((run, index) => (
            <li key={`${run}-${index}`} className="text-[11px] leading-4 text-cyber-muted">
              {run}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="text-[11px] text-cyber-muted">
      <span className="text-cyber-muted/70">Next runs: </span>
      {nextRuns.join(" · ")}
    </div>
  );
}
